var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLessThanOrEqualTo = function SvgLessThanOrEqualTo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "less than or equal to",
    d: "m4 5.35 8.5 3.51-.63 1.84L1.5 6.31V4.39L11.87 0l.63 1.85ZM1.5 12.1h11V14h-11Z"
  })));
};

export default SvgLessThanOrEqualTo;